import React, { useState } from 'react';
import { Send } from 'lucide-react';
import { toast } from 'sonner';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { TID } from '@/constants/testIds';

export const ContactSection = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);

  const onChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const onSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error('Please fill all fields');
      return;
    }
    setSent(true);
    toast.success("Thanks — we'll be in touch soon.");
    setForm({ name: '', email: '', message: '' });
    setTimeout(() => setSent(false), 4000);
  };

  return (
    <section
      id="contact"
      data-testid={TID.contactSection}
      className="cw-section"
      style={{ backgroundColor: 'rgba(153, 193, 241, 0.10)' }}
    >
      <div className="cw-container grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <span className="cw-label">Say hi</span>
          <h2 className="font-heading mt-3 text-4xl sm:text-5xl font-medium tracking-tight leading-tight">
            Questions, custom hampers, or a wholesale enquiry?
          </h2>
          <p className="mt-6 text-[var(--cw-muted)] leading-relaxed max-w-md">
            To place an order, <strong className="text-[var(--cw-text)]">drop us
            an email at <span className="whitespace-nowrap">orders@choco-wash.com</span></strong>{' '}
            with the soaps or chocolates you&apos;d like, your shipping address,
            and any gifting notes. We reply within two hours with
            confirmation and UPI details.
          </p>
          <div className="mt-4 text-sm text-[var(--cw-muted)]">
            <div className="cw-label mb-1">Studio</div>
            Nagpur, India
          </div>
        </div>

        <div className="md:col-span-7">
          <form
            onSubmit={onSubmit}
            data-testid={TID.contactForm}
            className="bg-white rounded-3xl p-8 border border-[var(--cw-border)] cw-soft-shadow grid gap-5"
          >
            <div className="grid sm:grid-cols-2 gap-5">
              <div>
                <label className="cw-label">Name</label>
                <Input
                  name="name"
                  value={form.name}
                  onChange={onChange}
                  placeholder="Your name"
                  className="mt-2 h-12 rounded-xl"
                  data-testid={TID.contactInput('name')}
                />
              </div>
              <div>
                <label className="cw-label">Email</label>
                <Input
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={onChange}
                  placeholder="you@example.com"
                  className="mt-2 h-12 rounded-xl"
                  data-testid={TID.contactInput('email')}
                />
              </div>
            </div>
            <div>
              <label className="cw-label">Message</label>
              <Textarea
                name="message"
                value={form.message}
                onChange={onChange}
                placeholder="What can we help with?"
                className="mt-2 min-h-[140px] rounded-xl"
                data-testid={TID.contactInput('message')}
              />
            </div>
            <button
              type="submit"
              className="cw-btn-primary justify-center"
              data-testid={TID.contactSubmit}
            >
              {sent ? 'Sent ✓' : 'Send message'} <Send className="w-4 h-4" />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};
